var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 15L16.2844 11.0344C16.2146 10.9636 16.1314 10.9073 16.0397 10.8689C15.9479 10.8305 15.8495 10.8107 15.75 10.8107C15.6505 10.8107 15.5521 10.8305 15.4603 10.8689C15.3686 10.9073 15.2854 10.9636 15.2156 11.0344L11.0344 15.2157C10.9646 15.2865 10.8814 15.3428 10.7897 15.3812C10.6979 15.4196 10.5995 15.4394 10.5 15.4394C10.4005 15.4394 10.3021 15.4196 10.2103 15.3812C10.1186 15.3428 10.0354 15.2865 9.96563 15.2157L8.03437 13.2844C7.96459 13.2136 7.8814 13.1573 7.78966 13.1189C7.69792 13.0805 7.59946 13.0607 7.5 13.0607C7.40054 13.0607 7.30208 13.0805 7.21034 13.1189C7.1186 13.1573 7.03541 13.2136 6.96563 13.2844L3.75 16.5",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 8.625C10.4375 9.2118 9.9618 9.6875 9.375 9.6875C8.7882 9.6875 8.3125 9.2118 8.3125 8.625C8.3125 8.0382 8.7882 7.5625 9.375 7.5625C9.9618 7.5625 10.4375 8.0382 10.4375 8.625Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.125
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImg);
export default __webpack_public_path__ + "static/media/ic-img.aead1be2feae9804e68b5b2b80a41d19.svg";
export { ForwardRef as ReactComponent };